/*
 * @author Oleksandr Papka <papkaos>
 */
angular.module('popup.system-package').directive('gccsPopupSystemPackageLicensesNumber', [
  'popupDirectiveConfig',
  popupDirectiveConfig =>
    popupDirectiveConfig.configure({
      bodyTemplate: require('./template.pug')
    })
]);
